<template>
  <el-dialog
    :title="title"
    :visible.sync="templeShowDialog"
    width="1000px"
    center
    :append-to-body="true"
    @open="handleOpen"
    @close="closeDialog"
    v-drag
  >
    <SiruiSearch
      ref="baseInfoFormRef"
      :query="baseFormData"
      :columns="formColumn"
      :rules="formRules"
      :isQueryPanel="false"
    ></SiruiSearch>
    <div class="bottom">
      <el-button type="primary" @click="closeDialog" class="btn-cancer">取消</el-button>
      <el-button type="primary" @click="save" :loading="load" class="btn-save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import {
    transformerColumn,
    lineColumn,
    areaColumn,
    regionColumn,
  } from './addTransformerDialog.js';
  import { electricityMeterAdd } from '@/api/property/model';
  import '@/utils/directives.js';
  export default {
    name: 'AddTransformerDialog',
    components: {},
    computed: {
      formColumn() {
        let columnList = [];
        if (this.meterType == '1') {
          columnList = transformerColumn(this);
        } else if (this.meterType == '2') {
          columnList = lineColumn(this);
        } else if (this.meterType == '3') {
          columnList = areaColumn(this);
        } else {
          columnList = regionColumn(this);
        }
        return columnList;
      },
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      meterNo: {
        type: String,
        default: '',
      },
      transformerDialogType: {
        type: String,
        default: 'add',
      },
      meterType: {
        type: String,
        default: '1',
      },
      companyCode: {
        type: String,
        default: '',
      },
      form: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        templeShowDialog: this.showDialog,
        baseFormData: JSON.parse(JSON.stringify(electricityMeterAdd)),
        formRules: {
          spaceId: [{ required: true, message: '请选择片区名称', trigger: 'blur' }],
          meterNo: [
            { required: true, message: '请输入电表编号', trigger: 'blur' },
            // { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
          ],
          transformer: [
            // { required: true, message: '请输入变压器名称', trigger: 'change' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
          ],
          line: [
            // { required: true, message: '请输入线路名称', trigger: 'change' },
            // { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
          ],
          smartFlag: [{ required: true, message: '请选择是否为智能电表', trigger: 'blur' }],
          areaName: [
            // { required: true, message: '请输入区域名称', trigger: 'change' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
          ],
          inductanceRatio: [
            { pattern: /^[0-9.]*$/, message: '请输入大于等于0的数字', trigger: 'blur' },
          ],
          loss: [{ pattern: /^[0-9.]*$/, message: '请输入大于等于0的数字', trigger: 'blur' }],
          meterReadingWarning: [
            { pattern: /^[0-9.]*$/, message: '请输入大于等于0的数字', trigger: 'blur' },
          ],
        },
        spaceNameList: [],
        load: false,
        title: '新增变压器总表',
      };
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },
    mounted() {},

    methods: {
      handleOpen() {
        this.baseFormData = JSON.parse(JSON.stringify(electricityMeterAdd));
        console.log(this.baseFormData);
        if (this.meterType == '1') {
          this.getArea();
        }
        if (this.transformerDialogType == 'edit') {
          this.getDetail();
        }
        this.titleSetting();
      },
      titleSetting() {
        if (this.meterType == '1') {
          this.title = '新增变压器总表';
          this.baseFormData.meterType = '变压器总表';
        } else if (this.meterType == '2') {
          this.title = '新增线路总表';
          this.baseFormData.meterType = '线路总表';
        } else if (this.meterType == '3') {
          this.title = '新增区域总表';
          this.baseFormData.meterType = '区域总表';
        } else {
          this.title = '新增区域子表';
          this.baseFormData.meterType = '区域子表';
        }
        if (this.transformerDialogType == 'edit') {
          this.title = this.title.replace(/新增/, '编辑');
        }
      },
      closeDialog() {
        this.$emit('closeDialog', false);
        this.$refs.baseInfoFormRef.resetForm('queryFrom');
        this.load = false;
      },
      // 保存
      save() {
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            if (this.baseFormData.spaceId != '' && this.meterType == '1') {
              let index = this.spaceNameList.findIndex(
                (item) => item.id == this.baseFormData.spaceId
              );
              this.baseFormData.spaceName = this.spaceNameList[index].name;
            }
            this.baseFormData.meterType = this.meterType;
            this.$emit('submit', this.baseFormData);
          }
        });
      },
      // 获取片区数据
      async getArea() {
        console.log('获取片区');
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, {
          companyNo: this.companyCode,
          id: '0',
        });
        if (data.code == 0) {
          this.spaceNameList = data.data;
        }
      },
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(MeterAPI.ELECTRIC_METER + '/' + this.meterNo);
        if (data.code == 0) {
          console.log('详情', data.data);
          this.baseFormData = data.data.electricMeter;
          this.baseFormData.smartFlag = data.data.electricMeter.smartFlag.toString();
          if (this.baseFormData.spaceId != null) {
            this.baseFormData.spaceId = data.data.electricMeter.spaceId.toString();
          }
          if (this.baseFormData.selfUseFlag != null) {
            this.baseFormData.selfUseFlag = data.data.electricMeter.selfUseFlag.toString();
          }
          if (this.baseFormData.virtualTableFlag != null) {
            this.baseFormData.virtualTableFlag =
              data.data.electricMeter.virtualTableFlag.toString();
          }
          if (this.baseFormData.inductanceRatio != null) {
            this.baseFormData.inductanceRatio = data.data.electricMeter.inductanceRatio.toString();
          }
          if (this.baseFormData.loss != null) {
            this.baseFormData.loss = data.data.electricMeter.loss.toString();
          }
          if (this.baseFormData.meterReadingWarning != null) {
            this.meterDetail.meterReadingWarning =
              data.data.electricMeter.meterReadingWarning.toString();
          }
          this.titleSetting();
        }
      },
    },
  };
</script>
<style scoped lang="scss">
  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }
  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .info {
    margin-top: 15px;
    margin-left: 20px;
    color: red;
  }
  .bottom {
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: center;
    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      margin-right: 20px;
      border: 0px solid #dcdfe6;
    }
    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }
</style>
